import { observer } from 'mobx-react-lite'
import React from 'react'
import Input from '../../../../FormComponents/Input'
import Switch from '../../../../FormComponents/Switch'

export default observer(function General({ values, setFieldValue, handleChange, handleBlur, campaign }) {

  return (
    <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-2xl p-4">
      <div className="flex justify-between items-center mb-8">
        <p className="font-bold text-xl dark:text-white">General</p>
        <Switch name="general_visible" value={values.general_visible} onChange={({ target: { checked }}) => setFieldValue('general_visible', checked, true)} eyeSwitch />
      </div>
      {values.general_visible && (
        <>
          <Input
            noLabelPadding
            label='Name of the campaign'
            name='campaign_name'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.campaign_name}
          />
          {campaign.image && <div className="h-18 rounded-lg border-1 dark:border-rb-dark-mode-lighter p-4 mt-4 flex dark:bg-rb-dark-mode-lighter">
            <img className="h-full" src={campaign.image} alt="logo" />
            <div className="ml-4">
              <p className="dark:text-gray-300">Client</p>
              <p className="font-bold dark:text-white">{campaign.client_name}</p>
            </div>
          </div>}
        </>
      )}
    </div>
  )
})